import { ParamMap } from '@angular/router';
import {
  FieldExtraConfig,
  FieldStyleConfig,
  SearchEngineField,
  SearchEngineFieldType,
  SearchEngineQueryParams,
  StaticNameFieldInputConfig,
} from '@domains/search-engine/search-engine-field';

export interface AddressValue {
  address?: string;
  id?: string;
}

export class SearchEngineFieldAddress extends SearchEngineField<AddressValue> {
  readonly type = SearchEngineFieldType.Address;

  constructor(inputConfig: StaticNameFieldInputConfig, extraConfig?: FieldExtraConfig, inputStyle?: FieldStyleConfig) {
    super({ ...inputConfig, name: 'address' }, extraConfig, inputStyle);
  }

  valueToQueryParams(value: AddressValue): { cityPlaceId?: string; address?: string } {
    if (value) {
      return {
        cityPlaceId: value?.id,
        address: value?.address,
      };
    }
    return {};
  }

  paramMapToValue(paramMap: ParamMap): AddressValue | null {
    const cityPlaceId = paramMap.get(SearchEngineQueryParams.CityPlaceId) ?? undefined;
    const address = paramMap.get(SearchEngineQueryParams.Address) ?? undefined;
    if (cityPlaceId || address)
      return {
        id: cityPlaceId,
        address,
      };
    return null;
  }
}
